<mat-card class="form-dialogo">
  <app-card-header
    [title]="title"
    [subtitle]="subtitle"
    icono="medical_services"
    [draggable]="true"
    [botonCerrar]="true"
    (cerrar)="close()"
  ></app-card-header>

  <mat-divider></mat-divider>

  @if (form && !loading) {
    <form
      id="form"
      [formGroup]="form"
      autocomplete="off"
      (ngSubmit)="onSubmit()"
    >
      <mat-card-content class="card-content-crear">
        <!-- Datos del profesional -->
        <app-content-card
          title="Datos del profesional"
          [icon]="iconoRol(form.get('rol')?.value)"
          color="blue"
        >
          <section class="inputs-group">
            <mat-form-field style="width: 100%">
              <mat-label>Nombre y apellido</mat-label>
              <input matInput formControlName="nombre" />
              <mat-icon matPrefix>person</mat-icon>
            </mat-form-field>

            <ng-select
              style="width: 100%"
              formControlName="rol"
              placeholder="Rol"
              [items]="roles"
              appendTo="body"
              notFoundText="Sin resultados"
            >
              <!-- Cada rol con su ícono (antes iba como prefijo del campo) -->
              <ng-template ng-option-tmp let-item="item">
                <span style="display: flex; align-items: center; gap: 8px">
                  <mat-icon>{{ iconoRol(item) }}</mat-icon>
                  {{ item }}
                </span>
              </ng-template>
            </ng-select>
          </section>

          <section class="inputs-group">
            <mat-form-field style="width: 100%">
              <mat-label>DNI</mat-label>
              <input matInput formControlName="dni" />
              <mat-icon matPrefix>badge</mat-icon>
            </mat-form-field>

            <mat-form-field style="width: 100%">
              <mat-label>Matrícula</mat-label>
              <input matInput formControlName="matricula" />
              <mat-icon matPrefix>card_membership</mat-icon>
            </mat-form-field>
          </section>

          <section class="inputs-group">
            @if (mostrarCliente && !id) {
              <app-cliente-selector
                formControlName="idCliente"
                style="width: 100%"
                [filterModules]="['moduloEmergenciasMedicas']"
                [showCrearBtn]="
                  helper.tienePermiso('Administración - Crear clientes')
                "
              ></app-cliente-selector>
            }

            <app-checkbox
              title="Activo (disponible para asignar)"
              formControlName="activo"
              margin="0 16px"
            ></app-checkbox>
          </section>
        </app-content-card>

        <!-- Contacto -->
        <app-content-card title="Contacto" icon="contacts" color="green">
          <section class="inputs-group">
            <mat-form-field style="width: 100%">
              <mat-label>Teléfono</mat-label>
              <input matInput formControlName="telefono" />
              <mat-icon matPrefix>phone</mat-icon>
            </mat-form-field>

            <mat-form-field style="width: 100%">
              <mat-label>Email</mat-label>
              <input matInput formControlName="email" type="email" />
              <mat-icon matPrefix>email</mat-icon>
              @if (form.get('email')?.hasError('email')) {
                <mat-error>Ingresá un email válido</mat-error>
              }
            </mat-form-field>
          </section>
        </app-content-card>
      </mat-card-content>

      <mat-divider></mat-divider>

      <mat-card-actions class="actions-create">
        <app-button
          matType="mat-fab extended"
          color="neutral"
          (click)="close()"
          text="Cancelar"
          icon="close"
        ></app-button>
        <app-button
          matType="mat-fab extended"
          color="primary"
          text="Guardar"
          icon="save"
          type="submit"
          [disabled]="!form.valid || guardando"
        ></app-button>
      </mat-card-actions>
    </form>
  } @else {
    <section class="inputs-group">
      <app-loading text="Cargando formulario…" [diameter]="60"></app-loading>
    </section>
  }
</mat-card>
